exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width-input[data-v-ce15339c]{width:100% !important}[data-v-ce15339c] .el-input__suffix{display:none}\n", ""]);

// exports
